module.exports = __webpack_public_path__ + "img/xmark.c896641a.svg";